angular
  .module('fca-used')
  .component('results', {
    bindings: {
      data: '<',
      dealers: '<'
    },
    templateUrl: 'app/results/results.html',
    controller: resultsController,
    controllerAs: 'results'
  });

resultsController.$inject = ['$window', '$state', '$stateParams', '$rootScope', '$timeout', '$localStorage', 'uvl', 'wishlist', 'tagging', 'ResultHelper', 'CONFIG'];

function resultsController($window, $state, $stateParams, $rootScope, $timeout, $localStorage, uvl, wishlist, tagging, ResultHelper, CONFIG) {
  var self = this;
  self.wishlist = wishlist;
  self.resultHelper = ResultHelper;

  self.orderOptions = CONFIG.order.fields;

  self.updatePage = function () {
    var begin = self.query.pagination.page * self.query.pagination.size;
    var end = begin + self.query.pagination.size;
    self.pagedData = self.data.vehicles.slice(begin, end);
    angular.forEach(self.pagedData, function (vehicle) {
      overrideVehicleLocation(vehicle);
    });
  };

  self.setPage = function (page) {
    self.query.pagination.page = Math.min(Math.max(0, page), self.query.pagination.pages.length - 1);
    self.filters.selectedPage = self.query.pagination.page;
    self.updatePage();
    var scrollTarget = $window.document.querySelector('.navigation-fca-used');
    scrollTarget.scrollIntoView({
      behavior: 'smooth'
    });
  };

  self.nextPage = function () {
    self.setPage(self.query.pagination.page + 1);
  };

  self.prevPage = function () {
    self.setPage(self.query.pagination.page - 1);
  };

  function renderPages() {
    self.query.pagination.page = self.filters.selectedPage || 0;
    self.query.pagination.pages = [];
    var pages = Math.ceil(self.total / self.query.pagination.size);
    if (pages > 1) {
      for (var i = 0; i < pages; i++) {
        self.query.pagination.pages.push(i + 1);
      }
    }
  }

  self.changedListOptions = function (updateLocally) {
    $localStorage.pageSize = self.query.pagination.size;
    renderPages();
    if (updateLocally) {
      self.updatePage();
    } else {
      self.update();
    }
  };

  self.changedSortingOptions = function () {
    ResultHelper.ordered = true;
    self.changedListOptions();
  };

  self.update = function () {
    if (self.query.location.geometry) {
      uvl.saveLastQuery(self.query);
      uvl.getVehicles(self.query)
        .then(function (vehicles) {
          self.data = vehicles;
          self.updatePage();
        });
    }
  };

  self.updateResults = function () {
    if (ResultHelper.lastQuery.submit) {
      ResultHelper.lastQuery.submit();
    }
  };

  self.newSearch = function () {
    ResultHelper.reset();
    $state.go('root.search');
  };

  /* eslint-disable complexity */
  self.$onInit = function () {
    /* eslint-enable complexity */
    if (CONFIG.mirafioriStripe && CONFIG.mirafioriStripe.selector) {
      var target = $window.document.querySelector(CONFIG.mirafioriStripe.selector);
      if (target) {
        target.style.display = 'none';
      }
    }

    if (angular.isUndefined($localStorage.gridView)) {
      $localStorage.gridView = true;
    }
    self.gridView = $localStorage.gridView;

    ResultHelper.lastQuery = uvl.getLastQuery();
    self.query = ResultHelper.getLastQuery();
    ResultHelper.filters = uvl.getLastFilters();
    self.filters = ResultHelper.filters;
    self.query.order = self.query.order || CONFIG.order.default;
    self.query.pagination = self.query.pagination || {
      page: 0,
      size: $localStorage.pageSize || CONFIG.pagination.default,
      sizes: CONFIG.pagination.sizes
    };
    self.total = self.data.numFound;
    renderPages();
    self.updatePage();
    resultTracking($stateParams.trackLoad);
    if ($stateParams.trackLoad) {
      resultTracking(false);
    }
  };

  function resultTracking(pageLoad) {
    var filterList = [];
    filterList.push({
      name: 'city',
      value: self.query.location.locality
    });
    filterList.push({
      name: 'distance',
      value: self.query.extendedArea
    });
    filterList.push({
      name: 'brand',
      value: self.query.filters.brand && CONFIG.brand && CONFIG.brand.taggingName ? CONFIG.brand.taggingName : 'NA'
    });
    filterList.push({
      name: 'model',
      value: self.query.filters.model && self.query.filters.model.modelDescription ? self.query.filters.model.modelDescription : 'NA'
    });
    filterList.push({
      name: 'price',
      value: self.query.filters.priceCurrent ? self.query.filters.priceCurrent.min + '-' + self.query.filters.priceCurrent.max : 'NA'
    });
    filterList.push({
      name: 'year',
      value: self.query.filters.registrationYear ? self.query.filters.registrationYear.min + '-' + self.query.filters.registrationYear.max : 'NA'
    });
    filterList.push({
      name: 'mileage',
      value: self.query.filters.km && CONFIG.search.mileage.min ? CONFIG.search.mileage.min + '-' + self.query.filters.km : 'NA'
    });

    filterList.push({
      name: CONFIG.search.premium.taggingId,
      value: self.query.filters.premium ? 'yes' : 'NA'
    });

    if (self.query.filters.fuel) {
      filterList.push({
        name: 'fuel',
        value: self.query.filters.fuel || 'NA'
      });
    }
    if (self.query.filters.power) {
      filterList.push({
        name: 'power',
        value: self.query.filters.power || 'NA'
      });
    }
    if (self.query.filters.gear) {
      filterList.push({
        name: 'gear',
        value: self.query.filters.gear || 'NA'
      });
    }
    if (self.query.filters.doors) {
      filterList.push({
        name: 'doors',
        value: self.query.filters.doors || 'NA'
      });
    }
    if (self.query.filters.color) {
      filterList.push({
        name: 'color',
        value: self.query.filters.color || 'NA'
      });
    }
    if (self.query.filters.transmission) {
      filterList.push({
        name: 'transmission',
        value: self.query.filters.transmission || 'NA'
      });
    }
    if (self.query.filters.vehicleType) {
      filterList.push({
        name: 'vehicle-type',
        value: self.query.filters.vehicleType || 'NA'
      });
    }
    if (self.query.filters.bodyType) {
      filterList.push({
        name: 'body-type',
        value: self.query.filters.bodyType || 'NA'
      });
    }
    if (self.query.filters.typeOfUse) {
      filterList.push({
        name: 'use-type',
        value: self.query.filters.typeOfUse || 'NA'
      });
    }
    if (self.query.filters.wheelBase) {
      filterList.push({
        name: 'wheel-base',
        value: self.query.filters.wheelBase || 'NA'
      });
    }
    if (self.query.filters.volume) {
      filterList.push({
        name: 'volume',
        value: self.query.filters.volume ? self.query.filters.volume.min + '-' + self.query.filters.volume.max : 'NA'
      });
    }
    if (self.query.filters.vatCode) {
      filterList.push({
        name: 'deductible-vat',
        value: self.query.filters.vatCode || 'NA'
      });
    }
    if (self.query.filters.damagedVehicle) {
      filterList.push({
        name: 'damaged-vehicle',
        value: self.query.filters.damagedVehicle || 'NA'
      });
    }
    var taggingOptions = {
      page: 'used:search',
      event: pageLoad ? 'pageload' : 'search',
      inventorySearch: {
        filterList: filterList.map(function (filter) {
          return filter.name + ':' + filter.value;
        }).join('|'),
        numberOfVehicles: self.total
      }
    };
    tagging.track(taggingOptions);
  }

  function overrideVehicleLocation(vehicle) {
    if (vehicle.locationOverriden) {
      return;
    }
    var dealer;
    for (var i = 0; i < vehicle.mandate.length && !dealer; i++) {
      var mandate = vehicle.mandate[i];
      var mandateBrand = $window.parseInt(mandate.brand);
      if (self.dealers[mandate.dealer]) {
        if (self.dealers[mandate.dealer][mandateBrand]) {
          var dealerBrandLocations = self.dealers[mandate.dealer][mandateBrand];
          dealer = dealerBrandLocations[0];
          // dealer = dealer || dealerBrandLocations[Object.keys(dealerBrandLocations)[0]];
        }
      }
    }

    vehicle.dealer = dealer || {};
  }

  self.openFiltersModal = function () {
    angular.element(document).find('html').css('position', 'fixed');
    angular.element(document).find('body').css('position', 'fixed');
    self.resultHelper.modalFilters = true;
    $timeout(function () {
      $rootScope.$broadcast('rzSliderForceRender');
    }, 50);
  };

  self.setGridView = function (gridView) {
    self.gridView = gridView;
    $localStorage.gridView = self.gridView;
  };
}
